import React, { useState, useEffect } from 'react';

function LiveCampaignsSidebar({setAlertModalState, audienceTypes, brandSizes, updateFilter}) {

  const [selectedFilters, setSelectedFilters] = useState({'audience': [], 'brandSize': []});
  const [audienceLabels, setAudienceLabels] = useState(undefined)

  useEffect(() => {
    var labels = audienceTypes
    labels.sort((a,b) => a[0].localeCompare(b[0]))
    setAudienceLabels(labels)
  }, [audienceTypes, brandSizes]);

  function updateSelectedFilters(e, filter, value){
    console.log('updating')
    console.log(selectedFilters)
    console.log(value)
    const data = {'audience': selectedFilters['audience'], 'brandSize': selectedFilters['brandSize']}
    if(!e.target.checked && selectedFilters[filter].includes(value))
      data[filter].pop(value)
    if(e.target.checked && !selectedFilters[filter].includes(value))
      data[filter].push(value)
    updateFilter(data)
  }

  return (
    <div className="space-y-8">
      {/* Alert */}
      <div className="relative shadow-1 bg-pink-400 rounded-sm p-5 min-w-60">
        <div className="absolute bottom-0 -mb-3">
          <svg width="44" height="42" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
              <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="ill-b">
                <stop stopColor="#fbbf24" offset="0%" />
                <stop stopColor="#fbbf24" offset="100%" />
              </linearGradient>
              <linearGradient x1="50%" y1="24.537%" x2="50%" y2="100%" id="ill-c">
                <stop stopColor="#fde68a" offset="0%" />
                <stop stopColor="white" stopOpacity="0" offset="100%" />
              </linearGradient>
              <path id="ill-a" d="m20 0 20 40-20-6.25L0 40z" />
            </defs>
            <g transform="scale(-1 1) rotate(-51 -11.267 67.017)" fill="none" fillRule="evenodd">
              <mask id="ill-d" fill="#fff">
                <use xlinkHref="#ill-a" />
              </mask>
              <use fill="url(#ill-b)" xlinkHref="#ill-a" />
              <path fill="url(#ill-c)" mask="url(#ill-d)" d="M20.586-7.913h25v47.5h-25z" />
            </g>
          </svg>
        </div>
        <div className="relative">
          <div className="text-sm font-medium text-white mb-2">Create an alert for campaigns you are
          interested in!</div>
          <div className="text-right">
            <button className="text-sm font-medium text-white hover:font-bold" onClick={() =>
              setAlertModalState({title: 'Contact Us ✉', message: 'To access this feature and others which facilitate greater ' +
                  'in-depth analysis, please send us an email (hello@empushy.com) and we will add you to our exclusive beta group.'})
            }>
              Create Alert -&gt;
            </button>
          </div>
        </div>
      </div>
      {/* White box */}
      <div className="bg-white shadow-1 rounded-sm border border-slate-200 p-5 min-w-60">
        <div className="grid md:grid-cols-2 xl:grid-cols-1 gap-6">
          {/* Group 1 */}
          <div>
            <div className="text-sm text-slate-800 font-semibold mb-3">Audience Types</div>
            <ul className="space-y-2">
              {audienceLabels!==undefined?audienceLabels.map((item) => {
                return (
                  <li key={item}>
                    <label className="flex items-center">
                      <input type="checkbox" className="form-checkbox"
                             onClick={(e)=>updateSelectedFilters(e, 'audience', item)}/>
                      <span className="text-sm text-slate-600 font-medium ml-2">{item}</span>
                    </label>
                  </li>
                );
              }):''}
            </ul>
          </div>
          {/* Group 2 */}
          {/*<div>
            <div className="text-sm text-slate-800 font-semibold mb-3">Company Culture</div>
            <div className="flex items-center">
              <div className="form-switch">
                <input
                  type="checkbox"
                  id="company-toggle"
                  className="sr-only"
                  checked={companySetting}
                  onChange={() => setCompanySetting(!companySetting)}
                />
                <label className="bg-slate-400" htmlFor="company-toggle">
                  <span className="bg-white shadow-sm" aria-hidden="true"></span>
                  <span className="sr-only">Company Culture</span>
                </label>
              </div>
              <div className="text-sm text-slate-400 italic ml-2">{companySetting ? 'On' : 'Off'}</div>
            </div>
            <div className="text-sm italic mt-3">Only show companies that are creating a positive culture</div>
          </div>*/}
          {/* Group 3 */}
          <div>
            <div className="text-sm text-slate-800 font-semibold mb-3">Brand Size</div>
            <ul className="space-y-2">
              {brandSizes!=undefined?brandSizes.map((item) => {
                return (
                  <li key={item}>
                    <label className="flex items-center">
                      <input type="checkbox" className="form-checkbox"
                             onClick={(e)=>updateSelectedFilters(e, 'brandSize', item)}/>
                      <span className="text-sm text-slate-600 font-medium ml-2">{item}</span>
                    </label>
                  </li>
                );
              }):''}
            </ul>
          </div>
          {/* Group 4 */}
          {/*<div>
            <div className="text-sm text-slate-800 font-semibold mb-3">Immigration</div>
            <div className="flex items-center">
              <div className="form-switch">
                <input
                  type="checkbox"
                  id="immigration-toggle"
                  className="sr-only"
                  checked={immigrationSetting}
                  onChange={() => setImmigrationSetting(!immigrationSetting)}
                />
                <label className="bg-slate-400" htmlFor="immigration-toggle">
                  <span className="bg-white shadow-sm" aria-hidden="true"></span>
                  <span className="sr-only">Immigration</span>
                </label>
              </div>
              <div className="text-sm text-slate-400 italic ml-2">{immigrationSetting ? 'On' : 'Off'}</div>
            </div>
            <div className="text-sm italic mt-3">Only show companies that can sponsor a visa</div>
          </div>*/}
        </div>
      </div>
    </div>
  );
}

export default LiveCampaignsSidebar;